import React, { useContext, useState, useEffect } from 'react';
import { KpiModel, initialKpi } from '../../core/_models';
import { getKpi } from '../../core/_requests';
import { DateRangeContext } from '@/components/context/DateRangeContext';
import { PaymentKpi } from '../kpi/PaymentKpi';
import { OrderKpi } from '../kpi/OrderKpi';
import { UserKpi } from '../kpi/UserKpi';
import { GlobalKpi } from '../kpi/GlobalKpi';
import { EarningsKpi, EarningsKpiSkeleton } from '../kpi/EarningsKpi';

const OverviewReportPane = () => {
  const { from, to, timezone } = useContext(DateRangeContext)
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<KpiModel>(initialKpi);

  const load = async () => {
    try {
      setIsLoading(true)
      await getKpi({ from, to, timezone }).then((data) => { void (data && setData(data)) });
    } catch (e: unknown) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    load();
  }, [from, to]);

  return (
    <>
      <div className="row align-items-center">
        <div className="col-xl-3">
          {isLoading ? (
            <EarningsKpiSkeleton />
          ) : (
            <EarningsKpi
              trx={data.trx.earnings}
              order={data.order.earnings}
              balance={data.balance}
            />
          )}
        </div>

        <div className="col-xl-4 ms-auto">
          <GlobalKpi data={data.kpi} isLoading={isLoading} />
        </div>
      </div>

      <div className="row my-5">
        <div className="col-xl-4">
          <PaymentKpi data={data.trx} isLoading={isLoading} />
        </div>

        <div className="col-xl-4">
          <OrderKpi data={data.order} isLoading={isLoading} />
        </div>

        <div className="col-xl-4">
          <UserKpi data={data.user} isLoading={isLoading} />
        </div>
      </div>
    </>
  );

};

export default OverviewReportPane
